module.exports = __webpack_public_path__ + "img/tsuki.b7bb8ae7.svg";